import { render, staticRenderFns } from "./video_main.vue?vue&type=template&id=f6bee898&"
import script from "./video_main.vue?vue&type=script&lang=js&"
export * from "./video_main.vue?vue&type=script&lang=js&"
import style0 from "./video_main.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports